import {updateCantidadArticuloAttachRecurso} from "../../../../../catalogo/articulos/selector-cantidad";

window.updateCantidadArticuloAttachRecurso = updateCantidadArticuloAttachRecurso;
$(document).ready(function () {
    $('#modalAttachArticuloRecursoBotonAdjuntar').on('click', function () {
        attachArticuloARecurso();
    });
});

window.mostrarModalAttachPlantillaComercial = function (articuloId, articuloUnidades, obj) {
    $("#attachArticuloRecursoCampoIdArticulo").val(articuloId);
    let cantidad;

    if (articuloUnidades > 0) {
        cantidad = $(`#product-id-${articuloId}`).find('.select-editable-units input').val().split('-')[0];
    } else {
        cantidad = $(`#product-id-${articuloId}`).find('.product-quantity-input input').val();
    }

    $("#attachArticuloRecursoCampoCantidad").val(cantidad);
    getRecursos();
    toggleMoreActions('#btn-multiple' + articuloId);
}

window.getRecursos               = async function (idRecurso = null) {
    if (!window.urlRecurso) {
        window.urlRecurso = urlPlantillasComerciales;
    }
    $.ajax({
        url:        window.urlRecurso + '/get',
        type:       'POST',
        dataType:   'json',
        beforeSend: function beforeSend() {
            $("#modalAttachArticuloRecurso .loadingResults").show();
            $("#modalAttachArticuloRecurso .sinResultados").hide();
            $("#modalAttachArticuloRecursoBotonAdjuntar").attr('disabled', true);
            $("#attachArticuloRecursoFormulario")
                .hide()
                .find('select')
                .html(``)
                .attr('disabled', true);
        },
    })
     .done(function (response) {
         if (response.list.length) {
             let html = '';
             response.list.forEach(recurso => {
                 html += `<option value="${recurso.id}">${recurso.titulo}</option>`;
             });
             $("#attachArticuloRecursoFormulario")
                 .show()
                 .find('select')
                 .html(html)
                 .attr('disabled', false);
             $("#modalAttachArticuloRecurso .sinResultados").hide();
             $("#modalAttachArticuloRecursoBotonAdjuntar").attr('disabled', false);
             if (idRecurso) {
                 $('#attachArticuloRecursoFormulario select').val(idRecurso);
             }
         } else {
             $("#modalAttachArticuloRecurso .sinResultados").show();
         }
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status) {
             var errors = '';
             if (jqXHR.status === 422) {
                 errors = composeValidationError(jqXHR.responseJSON.errors);
             } else if (jqXHR.responseJSON.message) {
                 errors = jqXHR.responseJSON.message;
             }
             pNotifyError(errors);
         }
     })
     .always(function () {
         $("#modalAttachArticuloRecurso .loadingResults").hide();
     });
}
let errors                       = '';
window.attachArticulosARecursoDB = function (idRecurso, dataToSend) {
    $.ajax({
        url:        window.urlRecurso + '/' + idRecurso + '/sync/articulos',
        type:       'POST',
        data:       dataToSend,
        dataType:   'json',
        beforeSend: function beforeSend() {
            $('#modalAttachArticuloRecursoBotonAdjuntar').prop('disabled', true);
            $('#modalAttachArticuloRecursoBotonAdjuntar').html("<i class=\"ri-loader-4-line ri-formatted spinner\"></i>".concat(transAccionProcesando));
        }
    })
     .done(function (response) {
         pNotifySuccess(response.message);
         $('#modalAttachArticuloRecursoBotonCerrar').click();
     })
     .fail(function (jqXHR, status, error) {
         if (jqXHR.status === 422) {
             errors = composeValidationError(jqXHR.responseJSON.errors);
         } else if (jqXHR.responseJSON.message) {
             errors = jqXHR.responseJSON.message;
         } else {
             errors = error;
         }
         pNotifyError(errors);
     })
     .always(function () {
         $('#modalAttachArticuloRecursoBotonAdjuntar').prop('disabled', false);
         $('#modalAttachArticuloRecursoBotonAdjuntar').html("<i class=\"ri-send-plane-2-fill ri-formatted\"></i>".concat(transAccionAnadirAPlantillaComercial));
     });
}

window.attachArticuloARecurso = function () {

    if (!$('#attachArticuloRecursoFormulario')[0].checkValidity()) {
        $("<input type=\"submit\">")
            .hide()
            .appendTo('#attachArticuloRecursoFormulario')
            .click()
            .remove();
    } else {
        cleanFeedback('attachArticuloRecurso', 'attachArticuloRecursoFormulario');
        const idRecurso = $('#attachArticuloRecursoCampoId').val();
        const id        = $('#attachArticuloRecursoCampoIdArticulo').val();
        const cantidad  = $('#attachArticuloRecursoCampoCantidad').val();

        const dataToSend = {
            sync_id:      {
                [id]: {cantidad},
            },
            detaching:    0,
            incrementing: 0
        }
        attachArticulosARecursoDB(idRecurso, dataToSend);
    }
}
